<script>
import { mapGetters } from 'vuex';
import Card from '@/online_booking/new/components/common/Card'
import GoogleAnalyticsEvents from 'Modules/GoogleAnalytics/resources/assets/js/GoogleAnalyticsEvents'
import EpBanner from 'Components/global/banner/index.vue';

    export default {
        components: {
	        EpBanner,
            Card
        },

        data: function () {
            return {
                booking: null,
                info: null,
                can_use_analytics: false,
                external_confirmation_url: '',
	            is_secure_messaging_active: false,
	            permalink: '',
                currency: Config.get('countries.' + locale + '.currency'),
            }
        },

        mounted: function () {

            this.$event_bus.$on('LoadData', (data) => {
                this.can_use_analytics = data.can_use_analytics;
                this.external_confirmation_url = data.online_booking_settings.external_confirmation_url;
				this.is_secure_messaging_active = data.is_secure_messaging_active;
				this.permalink = data.permalink;
            });


            this.$event_bus.$on('finish', (data) => {
                this.booking = data.data.booking;
                this.info = data.data;

                window.location.hash = 'finished';

                var chosen_service_amount = 0;

                if (data.chosen_service_amount) {
                    chosen_service_amount = data.chosen_service_amount;
                }

                if (this.can_use_analytics) {
                    GoogleAnalyticsEvents.BookingSubmitted.send({
                        'event_category': system_name,
                        'event_label': data.chosen_service_name,
                        'value': parseInt(chosen_service_amount) / 100,
                        'send_to': 'clientTracker',
                    })

                    if (data.paid_amount) {
                        GoogleAnalyticsEvents.BookingPaid.send({
                            'event_category': system_name,
                            'event_label': data.chosen_service_name,
                            'value': parseInt(data.paid_amount) / 100,
                            'send_to': 'clientTracker',
                        })
                    }

                    if (data.data.new_client_registered) {
                        GoogleAnalyticsEvents.ClientRegistered.send();
                    }
                }

                if (this.can_use_analytics && conversion_pixel_id && conversion_pixel_label && typeof gtag === 'function') {
                    gtag('event', 'conversion', {'send_to': 'AW-'+conversion_pixel_id+'/'+conversion_pixel_label, 'value': this.finalPrice, 'currency': this.currency});
                }

                if (data.data.facebook_pixel_id && data.data.facebook_conversion_event_code && typeof fbq === 'function') {
                    fbq('track', data.data.facebook_conversion_event_code, { value: parseFloat(chosen_service_amount / 100), currency: data.currency });
                }


                if(this.external_confirmation_url !== ''){

                    const waiting_list_entry = data?.data?.waiting_list_entry;
                    const redirect_times = this.getRedirectTimes(this.booking, waiting_list_entry);
                    const redirect_data = {
                        'calendar': data.calendar_id,
                        'service_name': data.chosen_service_name,
                        'service_price': data.chosen_service_amount ?  data.chosen_service_amount : 0,
                        'start_time': redirect_times.start_time,
                        'end_time': redirect_times.end_time,
                    };

                    window.location.replace(this.external_confirmation_url + "?" + this.encodeQueryData(redirect_data));
                }
            });
        },

        beforeUnmount() {
            this.$event_bus.$off('LoadData');
            this.$event_bus.$off('finish');
        },

        computed: {
            ...mapGetters([
                'finalPrice',
            ]),

            booking_date() {

                if(!this.booking){
                    return false;
                }

                return moment(this.booking.start.date).locale(moment_locale).format('D MMMM YYYY');
            },

            booking_time() {

                if(!this.booking){
                    return false;
                }

                let end = moment(this.booking.start.date).format('H:mm');
                end += ' - ';
                end += this.booking.end_time ? this.booking.end_time : moment(this.booking.end.date).format('H:mm');

                return end;
            },
        },

        methods: {
            restart() {
                location.reload();
            },
            encodeQueryData(data) {
                const ret = [];
                for (let d in data)
                    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
                return ret.join('&');
            },
            getRedirectTimes(booking, waiting_list_entry) {
                let start_time = ''
                let end_time = '';

                if (booking) {
                    start_time = booking.start?.date || '';
                    end_time = booking.end?.date || '';
                } else if (waiting_list_entry) {
                    start_time = waiting_list_entry.start_date?.date || '';
                    end_time = waiting_list_entry.end_date || '';
                }

                return { start_time: start_time, end_time: end_time };
            },
        },
    };


</script>


<template id="booking-success">

    <div v-if="booking" id="booking-success-panel">
        <div class="row">
            <div class="col-xs-12">
                <card class="rounded-lg">
                    <div id="booking-success-booking">
                        <div class="row">
                            <div class="text-center col-xs-12 m-t-40 m-b-30">
	                            <EpBanner
		                            v-if="is_secure_messaging_active"
		                            class="m-b-0"
	                            >
		                            {{ trans('online_booking.online_booking_secure_message_notice.message_prefix') }}
		                            <router-link :to="`/book/${permalink}/messages`" class="text-primary">
			                            {{ trans('online_booking.online_booking_secure_message_notice.message_link') }}
		                            </router-link>
		                            {{ trans('online_booking.online_booking_secure_message_notice.message_suffix') }}
	                            </EpBanner>
                                <i class="zmdi zmdi-check-circle booking-success-icon"></i>
                                <h3 class="m-b-30">
                                    {{ trans('online_booking.public_book_success') }}
                                    <span v-if="booking.isPaidOnline"><br>{{ trans('online_payment.receipt_received') }}</span>
                                </h3>
                                <button class="btn btn-lg btn-custom btn-trans" v-on:click="restart">
                                    <i class="zmdi zmdi-replay"></i>
                                    <span class="m-l-10">{{ trans('online_booking.book_new_time') }}</span>
                                </button>
                            </div>
                        </div>
                        <hr>
                        <div class="row m-t-30 m-b-20">
                            <div class="text-center col-xs-6 col-sm-4">
                                <i class="zmdi zmdi-calendar booking-success-details-icon"></i>
                                <div>
                                    <h5>{{ booking_date }}</h5>
                                </div>
                            </div>
                            <div class="text-center col-xs-6 col-sm-4">
                                <i class="zmdi zmdi-time booking-success-details-icon"></i>
                                <div>
                                    <h5>{{ booking_time }}</h5>
                                </div>
                            </div>
                            <div class="text-center col-sm-4" v-if="booking.booking_products && booking.booking_products.length > 0">
                                <i class="zmdi zmdi-assignment booking-success-details-icon"></i>
                                <div>
                                    <h5>
                                        <div class="m-b-5" v-for="bookingProduct in booking.booking_products" :key="bookingProduct.id">
                                            {{ bookingProduct.product.name }}
                                            <span class="text-muted" v-if="bookingProduct.addons && bookingProduct.addons.length > 0"
                                                  v-text="`(+ ${bookingProduct.addons.map(addonBookingProduct => addonBookingProduct.addon.name).join(', ')})`"
                                            ></span>
                                        </div>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </div>
    </div>

</template>
